import { fetchList, postNewRequest, updateWithdrawal, resendConfirmation, cancelConfirmation } from "@/api/withdrawal";

const state = {
  listItems: [],
  total: 0
};

const mutations = {
  SET_LIST_WITHDRAWALS: (state, data) => {
    state.listItems = data;
  },
  SET_TOTAL_WITHDRAWALS: (state, data) => {
    state.total = data;
  }
};

const actions = {
  fetchListWithdrawals({ commit }, query) {
    return new Promise((resolve, reject) => {
      fetchList(query)
        .then(response => {
          commit("SET_LIST_WITHDRAWALS", response.data);
          commit("SET_TOTAL_WITHDRAWALS", parseInt(response.headers["total"]));
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateWithdrawal({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateWithdrawal(data)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postNewWithdrawal({ commit }, data) {
    return new Promise((resolve, reject) => {
      postNewRequest(data)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  resendConfirmationWithdrawal({ commit }, id) {
    return new Promise((resolve, reject) => {
      resendConfirmation(id)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  cancelConfirmationWithdrawal({ commit }, id) {
    return new Promise((resolve, reject) => {
      cancelConfirmation(id)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const order = {
  state,
  mutations,
  actions,
  getters: {
    listWithdrawals: state => state.listItems,
    totalWithdrawals: state => state.total
  }
};

export default order;
